import { STATUS_CODES } from '@/utils/api/apiConstants';
export function handleApiResponse(response) {
	if (response && response.data && STATUS_CODES.SUCCESS_VALUES.includes(response.code)) {
		return true;
	}
	return false;
}
